import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f466867c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-color-mask" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, "重新着色（蒙版）：", -1))
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"flex":"1"}
}
const _hoisted_5 = {
  class: "row",
  style: {"margin-top":"15px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "蒙版颜色：", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "不透明度：", -1))

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ImageColorElementMask } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from './ColorButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementColorMask',
  setup(__props) {

const defaultColorMask = { color: 'transparent', opacity: 0.3 }

const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(useMainStore())

const colorMask = ref<ImageColorElementMask>(defaultColorMask)
const hasColorMask = ref(false)

const { addHistorySnapshot } = useHistorySnapshot()

watch(handleElement, () => {
  if (!handleElement.value || handleElement.value.type !== 'image') return

  if (handleElement.value.colorMask) {
    colorMask.value = handleElement.value.colorMask
    hasColorMask.value = true
  }
  else hasColorMask.value = false
}, { deep: true, immediate: true })

const toggleColorMask = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    slidesStore.updateElement({ id: handleElement.value.id, props: { colorMask: defaultColorMask } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'colorMask' })
  }
  addHistorySnapshot()
}

const updateColorMask = (colorMaskProp: Partial<ImageColorElementMask>) => {
  const newColorMask = { ...colorMask.value, ...colorMaskProp }
  slidesStore.updateElement({ id: handleElementId.value, props: { colorMask: newColorMask } })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Switch, {
          checked: hasColorMask.value,
          onChange: _cache[0] || (_cache[0] = checked => toggleColorMask(checked as boolean))
        }, null, 8, ["checked"])
      ])
    ]),
    (hasColorMask.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: colorMask.value.color,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = value => updateColorMask({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: colorMask.value.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Slider, {
              class: "opacity-slider",
              max: 1,
              min: 0,
              step: 0.05,
              value: colorMask.value.opacity,
              onChange: _cache[2] || (_cache[2] = value => updateColorMask({ opacity: value as number }))
            }, null, 8, ["step", "value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})